import authService from '../api-authorization/AuthorizeService';
import { ApplicationPaths, QueryParameterNames } from '../api-authorization/ApiAuthorizationConstants'

export class HandbookService {
	async getSections() {
		const response = await fetch('handbook/sections');
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
		return await response.json();
	}

	async getSubsectionTypes() {
		const response = await fetch('handbook/sections/subsection-types');
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
		return await response.json();
	}

	async getTemplateSections() {
		const token = await authService.getAccessToken();
		const response = await fetch('handbook/sections/template', {
			headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
		return await response.json();
	}

	async getAdminDocument() {
		const token = await authService.getAccessToken();
		const response = await fetch('handbook/admin/document', {
			headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
		});
		if (response.ok) return await response.json();
		if (response.status === 401) {
			window.location.href = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(window.location.href)}`;
		}
		throw new Error('HTTP error! Code: ' + response.status);
	}

	async saveAdminDocument(entity) {
		const token = await authService.getAccessToken();
		const headers = { 'content-type': 'application/json' };
		if (token) headers['Authorization'] = `Bearer ${token}`;
		const response = await fetch('handbook/admin/document', {
			method: 'PUT',
			body: JSON.stringify(entity),
			headers
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
	}

	async getAdminSections() {
		const token = await authService.getAccessToken();
		const response = await fetch('handbook/admin/sections', {
			headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
		});
		if (response.ok) return await response.json();
		if (response.status === 401) {
			window.location.href = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(window.location.href)}`;
		}
		throw new Error('HTTP error! Code: ' + response.status);
	}

	async getAdminSection(id) {
		const token = await authService.getAccessToken();
		const response = await fetch('handbook/admin/sections/' + id, {
			headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
		return await response.json();
	}

	async addSection(entity) {
		const token = await authService.getAccessToken();
		const headers = { 'content-type': 'application/json' };
		if (token) headers['Authorization'] = `Bearer ${token}`;
		const response = await fetch('handbook/admin/sections', {
			method: 'POST',
			body: JSON.stringify(entity),
			headers
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
	}

	async updateSection(id, entity) {
		const token = await authService.getAccessToken();
		const headers = { 'content-type': 'application/json' };
		if (token) headers['Authorization'] = `Bearer ${token}`;
		const response = await fetch('handbook/admin/sections/' + id, {
			method: 'PUT',
			body: JSON.stringify(entity),
			headers
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
	}

	async deleteSection(id) {
		const token = await authService.getAccessToken();
		const headers = {};
		if (token) headers['Authorization'] = `Bearer ${token}`;
		const response = await fetch('handbook/admin/sections/' + id, {
			method: 'DELETE',
			headers
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
	}

	async getAdminItems(sectionId) {
		const token = await authService.getAccessToken();
		const response = await fetch('handbook/admin/items?sectionId=' + encodeURIComponent(sectionId), {
			headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
		return await response.json();
	}

	async getAdminItem(id) {
		const token = await authService.getAccessToken();
		const response = await fetch('handbook/admin/items/' + id, {
			headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
		return await response.json();
	}

	async addItem(entity) {
		const token = await authService.getAccessToken();
		const headers = { 'content-type': 'application/json' };
		if (token) headers['Authorization'] = `Bearer ${token}`;
		const response = await fetch('handbook/admin/items', {
			method: 'POST',
			body: JSON.stringify(entity),
			headers
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
	}

	async updateItem(id, entity) {
		const token = await authService.getAccessToken();
		const headers = { 'content-type': 'application/json' };
		if (token) headers['Authorization'] = `Bearer ${token}`;
		const response = await fetch('handbook/admin/items/' + id, {
			method: 'PUT',
			body: JSON.stringify(entity),
			headers
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
	}

	async deleteItem(id) {
		const token = await authService.getAccessToken();
		const headers = {};
		if (token) headers['Authorization'] = `Bearer ${token}`;
		const response = await fetch('handbook/admin/items/' + id, {
			method: 'DELETE',
			headers
		});
		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
	}

	async uploadFile(file) {
		const token = await authService.getAccessToken();
		const formData = new FormData();
		formData.append('file', file);
		const headers = {};
		if (token) headers['Authorization'] = `Bearer ${token}`;

		const response = await fetch('handbook/admin/upload', {
			method: 'POST',
			body: formData,
			headers
		});

		if (!response.ok) throw new Error('HTTP error! Code: ' + response.status);
		return await response.json();
	}
}

const handbookService = new HandbookService();
export default handbookService;
